<template>
  <div>
    <v-text-field
      :class="{ 'is-invalid': !isValidate, css }"       
      :disabled="dis"
      v-model="selectedValue"
      @input="onSelect()"
      :outlined="outlined"
      :dense="dense"
      :rules="phoneRules"
    />   
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  props: [
    "value",
    "dis",
    "copyfrom_sourcefield",
    "copyfrom_title",
    "onchangedcallbackparam",
    "css",
    "outlined",
    "dense",
    "isRequired"        
  ],
  data() {
    return {
      selectedValue: this.value,
      expression:"^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$", 
      phoneRules:[
        v => !this.isRequired || (!!v || ''),
         v => (!this.isRequired && (!v || v.trim().length == 0)) || 
        (new RegExp(this.expression)).test(v) || 
        this.$t("errors.Invalid_Phone")
      ]
    };
  },
  computed: {
    isValidate() {
      return this.validatePhone();
    }
  },
  watch: {
    value(n, o) {
      this.selectedValue = n;
    }
  },
  methods: {
    onSelect() {
      if (this.selectedValue == "") {
        this.$emit("input", this.selectedValue);
        return;
      }
      var isvalid= this.validatePhone();
      if (isvalid) {
        this.$emit("input", this.selectedValue.replace(/\D/g, ''));
      }
      try {
        this.$emit("onchangedisvalidcallback", isvalid);
      } catch (e) {
        // ignore
      }
    },
    validatePhone() {      
      if (!this.selectedValue) {        
        return true;
      } else {       
        return (new RegExp(this.expression)).test(this.selectedValue);
      }
    },
    onCopyFrom() {
      try {
        this.selectedValue = this.copyfrom_sourcefield;
        this.$emit("input", this.selectedValue);
      } catch (e) {
        // ignore
      }
    }
  }  
};
</script>
